import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import UIContainer from '../../ui/container';
import styled from 'styled-components';
import { useTokenTranslate } from '../../../contexts/token_translation_context';

export const SELLER_BANNER_HEIGHT_PX = 40;
export const SELLER_BANNER_TOTAL_HEIGHT_CSS = `calc(${SELLER_BANNER_HEIGHT_PX}px + env(safe-area-inset-bottom, 0px))`;

const BecomeLemonadeSeller = () => {
  const { translate } = useTokenTranslate();
  const history = useHistory();

  const goToSellerApplication = useCallback(() => {
    history.push('/seller-application');
  }, [history]);

  return (
    <BecomeLemonadeSellerContainerWrapper>
      <VisibleBanner>
        <UIContainer>
          <Container>
            <StyledTriggerButton type='button' onClick={goToSellerApplication}>
              {translate('web.seller_application_page.eligibility_modal.trigger_button_text')}
            </StyledTriggerButton>
          </Container>
        </UIContainer>
      </VisibleBanner>

    </BecomeLemonadeSellerContainerWrapper>
  );
};

const BecomeLemonadeSellerContainerWrapper = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1200;
  width: 100vw;
  padding-bottom: env(safe-area-inset-bottom, 0px);

  @media only screen and (max-width: 430px) {
    position: static;
    left: auto;
    right: auto;
    bottom: auto;
    width: auto;
    padding-bottom: 0;
  }
`;

const VisibleBanner = styled.div`
  background-color: #F3FF65;
  box-shadow: 0 -6px 20px rgba(0, 0, 0, 0.08);
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8em;
  min-height: ${SELLER_BANNER_HEIGHT_PX}px;
  box-sizing: border-box;
`;

const StyledTriggerButton = styled.button`
  background: transparent;
  border: 0;
  color: #231F20;
  cursor: pointer;
  font-size: 1.2em;
  padding: 0;
  line-height: 1.2;

  &:hover {
    color: rgb(78, 77, 77);
    text-decoration: underline;
  }
`;

export default BecomeLemonadeSeller;
